import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

import { Menu } from '../../types/menu';

type MenuResponse = Menu[];

export const tenantMenuApiClient = {
  index: async (): Promise<ApiResult<MenuResponse>> => {
    return await axiosClient.get('/tenant/menus');
  },
};
